import React from 'react';
import times from 'lodash/times';
import { scaleLinear } from 'd3';
import angles from 'angles';

import Plot from '../../components/Plot';
import * as utils from '../../utils';

function WindspeedField({ size, sensors }) {
  return (
    <Plot size={size}>
      {({ xScale, yScale, actualSize }) => {

        const speedScale = scaleLinear().domain([0, Math.max(...sensors.map(sensor => sensor.speed))]).range([0, 10]);
        // TODO: Distribute points evenly based on height/width
        const points = []
        times(10, x => times(10, y => points.push({
          x: ((actualSize.width / 10) * x) + 5,
          y: ((actualSize.height / 10) * y) + 5,
        })))
        return points.map(point => {
          const location = {
            x: xScale.invert(point.x),
            y: yScale.invert(point.y),
          }
          const wind = sensors
            .map(sensor => ({
              ...sensor,
              distance: utils.getDistance(location, sensor),
            }))
            .sort((a, b) => a.distance - b.distance )
            .reduce((result, sensor, i, sortedSensors) => {
              if (i === 0) return sensor
              let weighting = 0.5 * (sortedSensors[0].distance / sensor.distance);
              const angleDiff = angles.diff(result.direction, sensor.direction);
              const speedDiff = result.speed - sensor.speed;

              return {
                direction: result.direction + (weighting * angleDiff),
                speed: result.speed + (weighting * speedDiff),
              }
            }, { direction: null, speed: null})
          if (!wind.speed) return null;
          return (
            <g
              transform={`
                translate(${point.x}, ${point.y})
                rotate(${Math.floor(wind.direction)})
              `}>
              <path
                d={`M0 0 L0 -${speedScale(wind.speed)}`}
                stroke="blue"
                stroke-width={2}
                fill="none"  
              />
              <polygon
                points={`-2,-${speedScale(wind.speed) - 4} 0,-${speedScale(wind.speed)} 2,-${speedScale(wind.speed) - 4}`}
                stroke="blue"
                stroke-width={1}
                fill="blue"  
              />
            </g>
          )
        })
      }}
    </Plot>
  )
}

WindspeedField.defaultProps = {
  offset: {
    x: 0,
    y: 0,
  },
}

export default WindspeedField;



// WEBPACK FOOTER //
// ./src/plots/WindspeedField/WindspeedField.component.js